<div class="container-fluid pl-0 pr-0 h-100 d-flex">
  <div class="row wrapper">
    <div class="col d-flex flex-column flex-grow-1 form-column">
      <app-page-header />
      <div class="router-outlet-wrapper position-relative">
        <router-outlet />
      </div>
    </div>
    <div class="col flex-grow-1 right-col d-none d-md-flex">
      <div class="wrapper">
        <app-text-carousel [tipsTexts]="tips" />
      </div>
    </div>
  </div>
</div>
